import axios from 'axios';

export const excelDownload = async () => {
  await axios
    .get(`/api/editExcel/partList`, {
      responseType: 'blob',
    })
    .then((response) => {
      const blob = new Blob([response.data]);
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `LIST OF PARTS ${
          new Date().toLocaleDateString('en-GB') || null
        } .xlsx`
      );
      link.click();
      URL.revokeObjectURL(link.href);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

